import styled, { css } from 'styled-components';

import Picture from 'components/picture';
import { LoyaltyLoader } from 'pages/loyalty/loyalty-loader';
import { primitive } from 'styles/constants/primitives';
import { delayUnmountHOC } from 'utils/delay-unmount-hoc';

export const CATEGORY_TRANSITION_TIME = 350;

const RewardContainer = styled.div``;
const CATEGORY_HEADER_HEIGHT = '2.75rem';
const CATEGORY_HEADER_WIDTH = '23.4375rem;';

export const DelayedUnmountRewardContainer = delayUnmountHOC(RewardContainer);

export const RewardCategoryAccordion = styled.li<{
  open: boolean;
  categoryHeight: number;
  isCurrentSelection: boolean;
}>`
  height: ${p => `calc(${p.open ? p.categoryHeight : 0}rem + ${CATEGORY_HEADER_HEIGHT})`};
  width: ${CATEGORY_HEADER_WIDTH};
  display: flex;
  width: 100%;
  transition: height ${CATEGORY_TRANSITION_TIME / 1000}s;
  overflow: hidden;
  flex-direction: column;
  background: ${Styles.color.white};

  ${p =>
    p.isCurrentSelection &&
    css`
      position: relative;
      z-index: ${Styles.zIndex.top};
    `}
`;

export const CategoryHeader = styled.h4`
  flex-shrink: 0;
  width: 100%;
  height: ${CATEGORY_HEADER_HEIGHT};
  padding: 0;
  margin: 0;
  border-bottom: 1px solid ${Styles.color.grey.four};
`;

export const AccordionTrigger = styled.button`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0 1rem;
  background-color: ${Styles.color.white};
  border: none;
  cursor: pointer;

  &[aria-expanded='true'] svg {
    transition: 0.35s;
    transform: rotate(180deg);
  }
`;

export const CategoryImage = styled(Picture)`
  height: 1.7rem;
  width: 1.7rem;
  margin-right: 0.75rem;
`;

export const CategoryLabel = styled.span`
  flex: 1;
  text-align: left;
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.25rem;
  font-weight: ${Styles.fontWeight.normal};
`;

export const LoyaltyRewardsTitle = styled.h3`
  background: ${primitive.$white};
  margin: 0;
  padding: 1rem;
  font-family: ${Styles.fontFamily.brand};
`;

export const StyledLoyaltyLoader = styled(LoyaltyLoader)`
  height: 80vh;
`;

export const EmptyStateContainer = styled.div`
  padding: 5em 3em;
`;
